import { createTypes } from '../../utils/helpers';

const APPROVAL_TYPES_FETCH_TYPES: any = createTypes(
  'APPROVAL_TYPES_FETCH_TYPES',
);
export { APPROVAL_TYPES_FETCH_TYPES };
